import React, { useState, useContext, useEffect } from 'react';
import { Col } from 'react-bootstrap';
import { StoreContext } from '../../Store';
import ExcludableDocumentRow from './ExcludableDocumentRow';
import { getCompanyRepresentativeStatus } from '../../apiCalls';
import { isChedDoc } from '../QAChecklistTab/utils';

const ListOfDocumentTypes = ({ docTypes, readOnly, setDocumentsByIndex }) => {
  const store = useContext(StoreContext);
  const [showRepresentativeDocument, setShowRepresentativeDocument] = useState(false);
  const [isRepresentativeChecked, setIsRepresentativeChecked] = useState(true);
  const setNewLoadDataModified = store.newLoadDataModified[1];

  const [repStatusCache, setRepStatusCache] = useState(null);

  const isEADDisabled = (directionSelected, multipleNeeNor, currentDocumentType) => {
    if (currentDocumentType !== 'EAD export declaration') return null;

    if (directionSelected !== '10' && directionSelected !== '11') return null;

    if (!multipleNeeNor) return null;

    return true;
  };

  const checkIfEADDisabled = (title) => {
    const directionSelected = store.directionSelected[0];
    const multipleNeeNor = store.multipleConsignors[0] || store.multipleInvoices[0];
    const isDisabled = isEADDisabled(directionSelected, multipleNeeNor, title);
    if (isDisabled)
      return {
        isDisabled,
        tip: 'This option is currently not available with the use of multiple consignors or invoices.',
      };
  };

  useEffect(() => {
    const fetchData = async (companyId) => {
      const data = await getCompanyRepresentativeStatus(companyId);

      if (!data || data.length === 0) {
        return false; // Return false if data is empty
      }

      return !!data[0]?.representative && data[0]?.representative !== '0';
    };

    const handleLogic = async () => {
      if (store.clientIDoptions?.[0]?.length && store.clientID[0]) {
        const [selectedClient] = store.clientIDoptions[0].filter((item) => item.id === parseInt(store.clientID[0]));
        //if we are opening a submitted load - readOnly is true - then we don't want to go inside the if
        const representativeStatus = repStatusCache ?? (await fetchData(store.clientID[0]));
        setRepStatusCache(representativeStatus);
        const repStored = store.loadId[0] ? store.representative?.[0] : representativeStatus;
        if (selectedClient && !readOnly) {
          //from work for CABS-1880 - representative can be 10 (No) or 20 (Yes)
          setShowRepresentativeDocument(selectedClient.representative === 20);
          setIsRepresentativeChecked(repStored);
        } else {
          // ensuring representative status is only fetched once (to prevent repeat requests)
          setShowRepresentativeDocument(representativeStatus);
          setIsRepresentativeChecked(repStored);
        }
      }
    };
    handleLogic();
  }, [store.clientID[0], store.clientIDoptions[0]]);

  useEffect(() => {
    store.representative[1](showRepresentativeDocument ? isRepresentativeChecked : false);
  }, [isRepresentativeChecked, showRepresentativeDocument]);

  return (
    <div>
      <div
        className="d-flex flex-column bold"
        style={{
          borderBottom: 'solid 1px #00000033',
          borderTop: 'solid 1px #00000033',
        }}
      >
        <div className="d-flex gap-2 align-items-center my-3 pe-3">
          <div className="align-self-start px-2 ms-3" style={{ maxWidth: '75px', minWidth: '75px' }}>
            Include
          </div>
          <Col xs="2" style={{ minWidth: '20rem' }}>
            Document
          </Col>
          <div style={{ minWidth: '5rem' }}>Location</div>
          <div className="ms-5 flex-grow-1">Information</div>
          <div style={{ minWidth: '5rem', textAlign: 'right', marginRight: '1rem' }}>QTY</div>
        </div>
      </div>
      <section className="order-form">
        <div className="d-flex flex-column" style={{ paddingBottom: readOnly ? '20px' : '' }}>
          {docTypes?.map(({ id, tips, text, formname, port, checked, title, qty }, idx) => {
            const isChed = isChedDoc({ title, formname });
            const { isDisabled, tip } = checkIfEADDisabled(title) || {};
            return (
              <ExcludableDocumentRow
                key={`${formname}-${idx}`}
                checked={isDisabled ? false : checked}
                title={title}
                tips={tip ?? tips}
                documentType={formname}
                documentDetails={text}
                location={port}
                onChange={(event) => {
                  setNewLoadDataModified(true);
                  setDocumentsByIndex(idx, { checked: event.target.value }, title);
                }}
                show={true}
                readOnly={isDisabled ?? readOnly}
                additionalMessage="This document will be included when the load is submitted"
                qty={qty}
                onQtyChange={
                  isChed
                    ? (newQty) =>
                        setDocumentsByIndex(idx, {
                          qty: newQty,
                        })
                    : undefined
                }
                qtyDisabled={!checked || !isChed}
              />
            );
          })}
          {showRepresentativeDocument && (
            <ExcludableDocumentRow
              key="representativeDocField"
              checked={isRepresentativeChecked}
              title="Representative"
              tips=""
              documentType="docTyperepresentative"
              documentDetails="Customer’s EORI will be added as the representative"
              location="N/A"
              onChange={(event) => {
                setNewLoadDataModified(true);
                setIsRepresentativeChecked(event.target.value);
              }}
              show={true}
              readOnly={readOnly}
              additionalMessage="The Customer's EORI will be included when the load is submitted"
            />
          )}
        </div>
      </section>
    </div>
  );
};

export default ListOfDocumentTypes;
